import { observer } from "mobx-react";
import React from "react";
import Icon from "../../components/Icons/Icon";

const WellComeWidget = observer(() => {
  const today = new Date();

  const formattedDate = today.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const fullName = localStorage.getItem("fullName");

  return (
    <div className="wellcomeWidgetContainer">
      <div className="wellcomeWidgetleft">
        <div className="wellComeWidgetTitlesContainer">
          <span className="wellcomeWidgetTitle">Welcome back,</span>
          <span className="wellcomeWidgetSubTitle1"> {fullName}</span>
        </div>
        <span className="wellcomeSubTitle2">Today is {formattedDate}.</span>
      </div>
      <div className="wellcomeWidgetRight">
        <Icon iconName="smile" className="smileIcon" />
      </div>
    </div>
  );
});

export default React.memo(WellComeWidget);
